class Popup {
  constructor (el) {
    this.el = el
    this.closePopupButton = this.el.querySelectorAll('.js-close-popup-button')
    this.overlay = this.el.querySelector('.js-popup-overlay')
    this.initDefault()
  }

  initDefault () {
    this.initEvents()
    this.el.classList.contains('active') ? this.el.style.display = 'block' : this.el.style.display = 'none'
  }

  initEvents () {
    this.closePopupButton.forEach( el => {
      el.addEventListener('click', e => this.closeButtonHandler(e))
    })
    this.overlay.addEventListener('click', e => this.close() )
  }

  closeButtonHandler (e) {
    e.preventDefault()
    this.close()
  }

  close () {
    $(this.el).fadeOut(150)
    this.el.classList.remove('active')
  }
}

window.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelectorAll(".js-popup");
  let popupsCollection = new Array();
  if ( el ) {
    el.forEach( el => {
      popupsCollection.push(new Popup(el))
    })
  }

  const openPopupButton = document.querySelectorAll('.js-open-popup-button')

  const openPopup = function (e) {
    e.preventDefault()
    const target = e.currentTarget
    const id = target.getAttribute('href') || target.getAttribute('data-popup-id')
    const popup = document.querySelector(id)
    popupsCollection.forEach( el => {
      el.close();
    } )
    $(popup).fadeIn(100, function () { $(this).css( 'display', 'block') })
    popup.classList.add('active')
  }
  
  openPopupButton.forEach ( el => {
    el.addEventListener('click', openPopup )
  })
});
